import { lxIsNumber } from "./lxIsNumber";
/**
 * Checks if a value is NOT a number.
 *
 * This is a more "intuitive" version of the native `isNaN`.
 *
 * The native functions `isNaN` and `Number.isNaN` are not intuitive because they return unexpected results, e.g.
 * `isNaN(true)` or `isNaN(null) returns `false` - but one might expect it to be `true`, since `null` or `true` are not
 *  proper numbers.
 *
 * To avoid confusion, you may use `lxIsNumber` or `lxIsNaN` instead.
 *
 *
 * See [isNaN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isNaN)
 * and [Number.isNaN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN) in the MDN.
 *

 * @example
 * lxIsNaN(1) // false
 * lxIsNaN(null) // true
 * lxIsNaN(undefined) // true
 * lxIsNaN("1") // true
 * lxIsNaN(NaN) // true
 * lxIsNaN(Infinity) // true
 *
 * @package Utils
 */
export function lxIsNaN(value) {
    return !lxIsNumber(value);
}
